import React from 'react';
import ChannelIcon from '../channelIcon';

const ChannelIconRenderer = React.memo(({ value }) => {
    return <ChannelIcon channel={value} />;
});

export default ChannelIconRenderer;